// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as actions from "../../js/actions";
import * as constants from "../../js/constants";
import * as utils from "../../js/utils";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [username, usernameSet] = useState("");
  const [password, passwordSet] = useState("");
  const [captcha, captchaSet] = useState("");
  const [showPassword, showPasswordSet] = useState(false);

  const userLoginStore = useSelector((state) => state.userLoginStore);
  const { data: dataUserLogin, load: loadUserLogin, error: errorUserLogin, fail: failUserLogin } = userLoginStore;

  useEffect(() => {
    if (dataUserLogin) {
      localStorage.setItem("userToken", JSON.stringify(dataUserLogin));
      utils.Sleep(10).then(() => navigate("/"));
    }
  }, [dataUserLogin]);

  const handlerLoginSubmit = async (e) => {
    try { e.preventDefault(); } catch (error) {}
    if (captcha && captcha !== "") {
      dispatch(utils.ActionConstructorUtility(
        { "Action-type": "USER_LOGIN", username, password },
        "/api/any/user/login/", "POST", 30000, constants.USER_LOGIN, false
      ));
    }
  };

  const handlerLoginReset = (e) => {
    try { e.preventDefault(); } catch (error) {}
    usernameSet("");
    passwordSet("");
  };

  return (
    <div style={{
      display: "flex",
      minHeight: "100vh",
      background: "#0F1923",
      fontFamily: "'Inter', Arial, sans-serif",
    }}>

      {/* ===== ЛЕВАЯ ЧАСТЬ — фото карьера ===== */}
      <div style={{
        flex: "1 1 55%",
        position: "relative",
        overflow: "hidden",
        display: "none",
      }} className="km-login-photo-panel">
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: "url('/static/img/background_3.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center 38%",
        }} />
        {/* тёплый scrim как на hero */}
        <div style={{
          position: "absolute", inset: 0,
          background: "linear-gradient(160deg, rgba(12,30,58,.78) 0%, rgba(20,45,80,.54) 32%, rgba(90,60,25,.3) 62%, rgba(150,95,30,.08) 100%)",
        }} />
        <div style={{ position: "relative", zIndex: 1, padding: "48px 52px", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          {/* Логотип */}
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div style={{
              width: 48, height: 48, borderRadius: 10,
              background: "rgba(255,255,255,.12)",
              backdropFilter: "blur(8px)",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <img src="/static/img/logo.svg" alt="КМ" style={{ height: 28, filter: "brightness(0) invert(1)" }} />
            </div>
            <div>
              <div style={{ color: "#fff", fontWeight: 700, fontSize: 15, lineHeight: 1.2 }}>АО «Костанайские</div>
              <div style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>Минералы»</div>
            </div>
          </div>
          {/* Цитата снизу */}
          <div>
            <div style={{ color: "#F2A900", fontSize: 11, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", marginBottom: 10 }}>
              Внутренний портал предприятия
            </div>
            <div style={{ color: "#fff", fontSize: 28, fontWeight: 700, lineHeight: 1.25, marginBottom: 8, maxWidth: 420 }}>
              Платформа для всех работников
            </div>
            <div style={{ color: "rgba(255,255,255,.65)", fontSize: 14, lineHeight: 1.6 }}>
              Расчётные листы, данные по отпуску, послужной список и банк идей — в одном месте.
            </div>
          </div>
        </div>
      </div>

      {/* ===== ПРАВАЯ ЧАСТЬ — форма входа ===== */}
      <div style={{
        flex: "1 1 45%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
        padding: "40px 32px",
        minWidth: 320,
        position: "relative",
      }}>

        {/* Логотип для мобильных (скрыт на десктопе) */}
        <div className="km-login-mobile-logo" style={{ display: "none", marginBottom: 32, textAlign: "center" }}>
          <img src="/static/img/logo.png" alt="Костанайские минералы" style={{ height: 48 }} />
          <div style={{ marginTop: 8, fontSize: 13, color: "#5B6472", fontWeight: 600 }}>АО «Костанайские Минералы»</div>
        </div>

        <div style={{ width: "100%", maxWidth: 380 }}>

          {/* Заголовок */}
          <div style={{ marginBottom: 32 }}>
            <h1 style={{ fontSize: 26, fontWeight: 800, color: "#1C2128", margin: "0 0 6px", lineHeight: 1.2 }}>
              Добро пожаловать
            </h1>
            <p style={{ fontSize: 14, color: "#5B6472", margin: 0 }}>
              Войдите в систему чтобы продолжить
            </p>
          </div>

          {/* Статус */}
          {errorUserLogin && (
            <div style={{
              background: "#FBEAEA", border: "1px solid #F5C6C6", borderRadius: 10,
              padding: "10px 14px", marginBottom: 16, display: "flex", alignItems: "center", gap: 8,
              fontSize: 13, color: "#C0392B"
            }}>
              <i className="fa-solid fa-circle-exclamation" />
              {typeof errorUserLogin === "string" ? errorUserLogin : "Неверный ИИН или пароль"}
            </div>
          )}
          {failUserLogin && (
            <div style={{
              background: "#FBEAEA", border: "1px solid #F5C6C6", borderRadius: 10,
              padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#C0392B"
            }}>
              <i className="fa-solid fa-wifi m-0 p-1" />
              Ошибка соединения с сервером
            </div>
          )}
          {dataUserLogin && (
            <div style={{
              background: "#E8F8EF", border: "1px solid #A8DEC0", borderRadius: 10,
              padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#1E9E6B"
            }}>
              <i className="fa-solid fa-circle-check m-0 p-1" />
              Вы успешно вошли!
            </div>
          )}

          {/* Капча предупреждение */}
          {!captcha && username && password && (
            <div style={{
              background: "#FEF4DD", border: "1px solid #F2D88B", borderRadius: 10,
              padding: "9px 14px", marginBottom: 16, display: "flex", alignItems: "center", gap: 8,
              fontSize: 12.5, color: "#8A6000"
            }}>
              <i className="fa-solid fa-robot" />
              Пройдите проверку на робота ниже
            </div>
          )}

          {/* ИИН */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12.5, fontWeight: 600, color: "#5B6472", display: "block", marginBottom: 6 }}>
              ИИН (12 цифр)
            </label>
            <div style={{ position: "relative" }}>
              <i className="fa-solid fa-id-card" style={{
                position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
                color: "#9BA6B2", fontSize: 15, pointerEvents: "none"
              }} />
              <input
                type="text"
                className="form-control"
                value={username}
                placeholder="введите ИИН..."
                required
                minLength="12"
                maxLength="12"
                onChange={(e) => usernameSet(e.target.value.replace(utils.GetRegexType({ numbers: true }), ""))}
                autoComplete="current-username"
                style={{
                  paddingLeft: 42, height: 48, borderRadius: 10, fontSize: 15,
                  border: "1.5px solid #E4E7EC", outline: "none",
                  transition: "border-color .15s",
                }}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
            </div>
            <div style={{ fontSize: 11, color: "#9BA6B2", marginTop: 4 }}>
              Только цифры · 12 символов · обязательно
            </div>
          </div>

          {/* Пароль */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 6 }}>
              <label style={{ fontSize: 12.5, fontWeight: 600, color: "#5B6472" }}>
                Пароль
              </label>
              <Link to="/recover_password" style={{ fontSize: 12, color: "#1753A9", textDecoration: "none", fontWeight: 600 }}>
                Забыли пароль?
              </Link>
            </div>
            <div style={{ position: "relative" }}>
              <i className="fa-solid fa-lock" style={{
                position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)",
                color: "#9BA6B2", fontSize: 15, pointerEvents: "none"
              }} />
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="password"
                value={password}
                placeholder="введите пароль..."
                required
                minLength="8"
                maxLength="16"
                onChange={(e) => passwordSet(e.target.value.replace(utils.GetRegexType({ numbers: true, latin: true, lowerSpace: true }), ""))}
                autoComplete="current-password"
                style={{
                  paddingLeft: 42, paddingRight: 48, height: 48, borderRadius: 10, fontSize: 15,
                  border: "1.5px solid #E4E7EC",
                  transition: "border-color .15s",
                }}
                onFocus={(e) => e.target.style.borderColor = "#1753A9"}
                onBlur={(e) => e.target.style.borderColor = "#E4E7EC"}
              />
              <button
                type="button"
                onClick={() => showPasswordSet(!showPassword)}
                style={{
                  position: "absolute", right: 0, top: 0, bottom: 0,
                  width: 46, background: "none", border: "none", cursor: "pointer",
                  color: "#9BA6B2", display: "flex", alignItems: "center", justifyContent: "center",
                }}
              >
                <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 15 }} />
              </button>
            </div>
            <div style={{ fontSize: 11, color: "#9BA6B2", marginTop: 4 }}>
              Латиница, цифры и _ · от 8 до 16 символов
            </div>
          </div>

          {/* reCAPTCHA */}
          <div style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}>
            <ReCAPTCHA
              sitekey="6LchKGceAAAAAPh11VjsCtAd2Z1sQ8_Tr_taExbO"
              onChange={(e) => captchaSet(e)}
            />
          </div>

          {/* Кнопки */}
          <button
            type="button"
            onClick={handlerLoginSubmit}
            disabled={!captcha || loadUserLogin}
            style={{
              width: "100%", height: 50, borderRadius: 12, border: "none",
              background: captcha && !loadUserLogin ? "#1753A9" : "#B8C8E0",
              color: "#fff", fontSize: 15, fontWeight: 700,
              cursor: captcha && !loadUserLogin ? "pointer" : "not-allowed",
              display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
              transition: "background .15s, transform .1s",
              marginBottom: 10,
            }}
            onMouseEnter={(e) => { if (captcha && !loadUserLogin) e.target.style.background = "#103E80"; }}
            onMouseLeave={(e) => { if (captcha && !loadUserLogin) e.target.style.background = "#1753A9"; }}
          >
            {loadUserLogin
              ? <><span className="spinner-border spinner-border-sm" style={{ width: 18, height: 18 }} /> Входим...</>
              : <><i className="fa-solid fa-circle-check" /> Войти в систему</>
            }
          </button>

          <button
            type="button"
            onClick={handlerLoginReset}
            style={{
              width: "100%", height: 44, borderRadius: 12,
              background: "none", border: "1.5px solid #E4E7EC",
              color: "#5B6472", fontSize: 14, fontWeight: 600, cursor: "pointer",
              transition: "border-color .15s",
            }}
            onMouseEnter={(e) => e.target.style.borderColor = "#1753A9"}
            onMouseLeave={(e) => e.target.style.borderColor = "#E4E7EC"}
          >
            <i className="fa-solid fa-rotate-left m-0 p-1" />
            Сбросить
          </button>

        </div>

        {/* Подвал формы */}
        <div style={{ position: "absolute", bottom: 20, left: 0, right: 0, textAlign: "center", fontSize: 11, color: "#B0B8C4" }}>
          © 2026 АО «Костанайские Минералы»
        </div>
      </div>

      {/* CSS для адаптива */}
      <style>{`
        @media (min-width: 768px) {
          .km-login-photo-panel { display: flex !important; }
          .km-login-mobile-logo { display: none !important; }
        }
        @media (max-width: 767px) {
          .km-login-mobile-logo { display: block !important; }
        }
      `}</style>

    </div>
  );
};
